import { render, staticRenderFns } from "./ItemCustomColor.vue?vue&type=template&id=4a99099c&scoped=true&"
import script from "./ItemCustomColor.vue?vue&type=script&lang=ts&"
export * from "./ItemCustomColor.vue?vue&type=script&lang=ts&"
import style0 from "./ItemCustomColor.vue?vue&type=style&index=0&id=4a99099c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a99099c",
  null
  
)

export default component.exports